import { render, staticRenderFns } from "./transferActiveList.vue?vue&type=template&id=a3c404e0&scoped=true"
import script from "./transferActiveList.vue?vue&type=script&lang=js"
export * from "./transferActiveList.vue?vue&type=script&lang=js"
import style0 from "./transferActiveList.vue?vue&type=style&index=0&id=a3c404e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c404e0",
  null
  
)

export default component.exports